<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <!--
        Background overlay, show/hide based on modal state.
    
        Entering: "ease-out duration-300"
          From: "opacity-0"
          To: "opacity-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100"
          To: "opacity-0"
      -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
        Modal panel, show/hide based on modal state.
    
        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div>
        <div class="px-4" v-if="feautureType === 'own_number'">
          <h2 class="mt-2 text-lg font-bold tracking-tight text-gray-900">
            Send from Own Number
          </h2>
          <p class="mt-2">
            If you would like to send from your own number. It's part of our
            advanced plan, and we will apply to WhatsApp business API for your
            number.
            <br />
          </p>
          <p class="mt-2">
            <b>Requirements for sending from own number</b>
            <br />
            1) Facebook business manager account
            <br />
            2) You can use the free US WhatsApp number or your phone number not
            attached to any WhatsApp Mobile or business app
          </p>
        </div>

        <div class="px-4" v-if="feautureType === 'custom_template'">
          <h2 class="mt-2 text-lg font-bold tracking-tight text-gray-900">
            Customize the template
          </h2>
          <p class="mt-2">
            Customising templates are part of our advanced plan. Please upgrade
            to customize.
          </p>
        </div>
      </div>
      <div v-if="feautureType == 'marketing'">
        <div class="px-4">
          <h2 class="mt-2 text-lg font-bold tracking-tight text-gray-900">
            Marketing Messages
          </h2>
          <p class="mt-2">
            Whatsapp Marketing is part of our advanced plan, and we will apply
            to WhatsApp business API for your number.
            <br />
          </p>
          <p class="mt-2">
            <b>Requirements for whatsapp API approval</b>
            <br />
            1) Facebook business manager account
            <br />
            2) You can use the free US WhatsApp number or your phone number not
            attached to any WhatsApp Mobile or business app
          </p>
        </div>
      </div>
      <div v-if="feautureType == 'followup_reminder'">
        <div class="px-4">
          <h2 class="mt-2 text-lg font-bold tracking-tight text-gray-900">
            Follow Up Messages
          </h2>
          <p class="mt-2">
            Follow Up reminders is part of our advanced plan, and we will apply
            to WhatsApp business API for your number.
            <br />
          </p>
          <p class="mt-2">
            <b>Requirements for whatsapp API approval</b>
            <br />
            1) Facebook business manager account
            <br />
            2) You can use the free US WhatsApp number or your phone number not
            attached to any WhatsApp Mobile or business app
          </p>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            class="Polaris-Button Polaris-Button--primary disabled:opacity-50"
            type="button"
            @click="gotoPlans"
          >
            <span class="Polaris-Button__Content">
              <span class="Polaris-Button__Text">Goto Plans</span>
            </span>
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="close"
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    feautureType: {
      type: String
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    gotoPlans() {
      this.close();
      this.$router.push({ name: "Plan" });
    }
  }
};
</script>

<style lang="scss" scoped></style>
